<template>
  <div class="user" ref="user" :style="setScroll">
    <b-tabs
      v-if="!showForgotPassword"
      position="is-centered is-info"
      class="block"
    >
      <b-tab-item :label="$t('user.login')" icon="account">
        <Login @forgotPassword="showForgotPassword = true" />
      </b-tab-item>
      <b-tab-item :label="$t('user.register')" icon="account-plus">
        <Register />
      </b-tab-item>
    </b-tabs>
    <ForgotPassword
      v-if="showForgotPassword"
      @cancel="showForgotPassword = false"
      @close="closeForgetPassword"
    />
  </div>
</template>

<script>
import Login from "./Login";
import Register from "./Register";
import ForgotPassword from "./ForgotPassword";
import { setScroll } from "../../mixins/setScroll.js";

export default {
  name: "User",
  data: () => {
    return {
      showForgotPassword: false,
      scrollStyle: null,
      clientHeight: 0
    };
  },
  mixins: [setScroll],
  mounted() {
    this.$nextTick(() => {
      this.clientHeight = this.$refs.user.clientHeight;
    });
  },
  computed: {
    setScroll() {
      const height = this.clientHeight + 100;
      document.body.style.overflowY = "hidden";

      if (height > this.windowHeight) {
        document
          .getElementById("pinwallHtml")
          .setAttribute("style", "overflow-y:hidden !important");
        return `height: ${this.windowHeight -
          60}px;overflow-y:auto;overflow-x:hidden;`;
      } else {
        document
          .getElementById("pinwallHtml")
          .setAttribute("style", "overflow-y:auto !important");
      }
      return "";
    }
  },
  methods: {
    closeForgetPassword() {
      this.showForgotPassword = false;
    }
  },
  components: {
    Login,
    Register,
    ForgotPassword
  }
};
</script>
